module.exports = __webpack_public_path__ + "img/queenslander-type-1.663aeb42.jpg";